/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var FORMAT_INPUT_CONFIG = {
  RGB: [{
    key: "r",
    min: 0,
    max: 255,
    type: "inputNumber"
  }, {
    key: "g",
    min: 0,
    max: 255,
    type: "inputNumber"
  }, {
    key: "b",
    min: 0,
    max: 255,
    type: "inputNumber"
  }],
  HSV: [{
    key: "h",
    min: 0,
    max: 360,
    type: "inputNumber"
  }, {
    key: "s",
    min: 0,
    max: 100,
    type: "inputNumber"
  }, {
    key: "v",
    min: 0,
    max: 100,
    type: "inputNumber"
  }],
  HSL: [{
    key: "h",
    min: 0,
    max: 360,
    type: "inputNumber"
  }, {
    key: "s",
    min: 0,
    max: 100,
    type: "inputNumber"
  }, {
    key: "l",
    min: 0,
    max: 100,
    type: "inputNumber"
  }],
  CMYK: [{
    key: "c",
    min: 0,
    max: 255,
    type: "inputNumber"
  }, {
    key: "m",
    min: 0,
    max: 255,
    type: "inputNumber"
  }, {
    key: "y",
    min: 0,
    max: 255,
    type: "inputNumber"
  }, {
    key: "k",
    min: 0,
    max: 255,
    type: "inputNumber"
  }],
  CSS: [{
    key: "css",
    type: "input",
    flex: 3
  }],
  HEX: [{
    key: "hex",
    type: "input",
    flex: 3
  }]
};

export { FORMAT_INPUT_CONFIG, FORMAT_INPUT_CONFIG as default };
//# sourceMappingURL=config.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/color-picker/panel/format/config.js
// module id = null
// module chunks = 